import Navbar from "src/components/Navbar";
import Footer from "src/components/Footer";
import FeedbackForm from "src/components/FeedbackForm";
import useScrollToTop from "src/hooks/useScrollToTop";

const Feedback = () => {
  // Use the scroll to top hook
  useScrollToTop();

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow py-6 sm:py-8 lg:py-12">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm lg:grid lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)]">
            <section className="bg-purple-50/70 px-6 py-8 sm:px-8 sm:py-10 lg:flex lg:items-center lg:border-r lg:border-gray-200 lg:px-10 lg:py-12">
              <p className="max-w-lg text-xl leading-relaxed text-gray-600">
                Your feedback helps us improve our platform and provide better
                learning experiences.
              </p>
            </section>

            <section className="px-6 py-8 sm:px-8 sm:py-10 lg:px-10 lg:py-12">
              <FeedbackForm />
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Feedback;
